export class Permission {
	permissionId: number;
	create: boolean;
	update: boolean;
	read: boolean;
	delete: boolean;
	roleId?: number;

	constructor(permissionId: number) {
		this.permissionId = permissionId;
		this.create = false;
		this.update = false;
		this.read = false;
		this.delete = false;
	}
}

export class PermissionResponse {
	id: number;
	positionId: number;
	roleId: number;
	create: boolean;
	read: boolean;
	update: boolean;
	delete: boolean;
	creationDate: any;
	updateDate: any;
	userCreator: number;
	company: number;
}

export class PermissionInAdminRequest {
	permissions: Permission[];
	email: string;
	company: number;
}